import React from 'react';
import { Box, Card, Typography, Link, CardContent, CardMedia, CardActions } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import IbssSvgIcon from '../../Icons/SvgIcon/IbssSvgIcon';
import BuildingOverviewIcon from '../../Icons/BuildingOverviewIcon';

class IbssQuickLinkCard extends React.Component<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state = {
            imageError: false
        };
    }
 
    public handleImageError(): void
    {
        this.setState({ imageError: true });
    }
 
    public render(): JSX.Element
    {
        const { title, subtitle, additionalInfo, buttonLabel, iconSrc, iconAlt, destinationUrl } = this.props;
        const { imageError } = this.state as IState;
 
        const shouldShowImage = iconSrc && !imageError;

        return (
            <Card>
                <Box sx={{ display: 'flex' }}>
                    {shouldShowImage && (
                        <Box sx={{ height: 130, width: 130 }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '100%', height: '100%' }}
                                src={iconSrc}
                                alt={iconAlt}
                                onError={() => this.handleImageError()}
                            />
                        </Box>
                    )}
 
                    <CardContent sx={{ width: shouldShowImage ? '75%' : '100%' }}>
                        <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} height={'100%'}><Box>
                            <Typography variant="h6" className='overflow-ellipsis' sx={{ fontSize: '18px', color: (theme) => theme.palette.text.primary }} >
                                {title}
                            </Typography>
                            <Typography variant="body2" className='overflow-ellipsis' sx={{ color: (theme) => theme.palette.text.secondary }}>
                                {subtitle}
                            </Typography>
                        </Box>
                            <Box>
                                {additionalInfo && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '4px' }}>
                                        <IbssSvgIcon>
                                            <BuildingOverviewIcon />
                                        </IbssSvgIcon>
                                        <Typography variant="body2"
                                            sx={{
                                                display: 'block', 
                                                color: 'var(--ui-text-light)',
                                                width: '90%', 
                                                whiteSpace: 'nowrap', 
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}>
                                            {additionalInfo}
                                        </Typography>
                                    </Box>
                                )}
                            </Box >
                        </Box>
                    </CardContent>
                </Box>
                <CardActions>
                    {destinationUrl && (
                        <Link variant="body2" href={destinationUrl} target="_blank" rel="noopener noreferrer"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%',
                                color: (theme) => theme.palette.primary.main,
                                textDecoration: 'none', '&:hover': { textDecoration: 'underline' }
                            }}>
                            <Typography variant="body2" className='overflow-ellipsis' sx={{ width: '70%' }}>
                                {buttonLabel}</Typography>
                            <OpenInNewIcon sx={{ fontSize: '16px', marginLeft: '4px' }} />
                        </Link>
                    )}
                </CardActions>
            </Card>
        );
    }
}
 
export default IbssQuickLinkCard;
 
interface IProps
{
    title: string;
    subtitle?: string;
    additionalInfo?: string;
    buttonLabel: string;
    iconSrc?: string;
    iconAlt?: string;
    destinationUrl: string | null;
}
 
interface IState
{
    imageError: boolean;
}